import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import { Search } from 'components/Search';
import { NotFound } from 'components/NotFound/NotFound';
import { Pagination } from 'components/Pagination';
import { usePageSize } from 'hook/usePageSize';

import { ListItem } from './ListItem';
import { Add } from '../Add';
import { useAuth } from 'lib/auth';
import { Loader } from 'components/Loader';
import { getStatus } from '../../utils/getStatus';

export const MyAdsListView = ({
  jobAds,
  total,
  isFetching,
  page,
  handleSearchChange,
  handlePageChange,
  refetch,
  adminView, // Add adminView prop
  filters,
}) => {
  const { account, user } = useAuth();
  const [pageSize, setPageSize] = usePageSize();
  const isSupplier = !account.super_admin && user?.Company?.Type === 'supplier';
  const isBuyer = !account.super_admin && user?.Company?.Type === 'buyer';
  const companyID = account.super_admin ? -1 : (isSupplier || isBuyer) ? user?.Company?.company_id : 0;
  const caption = (isSupplier || isBuyer) ? 'Click the "Add Advertisement" button to begin' : '';

  const showAddButton = (adminView && account.super_admin) || (!adminView && (isSupplier || isBuyer));

  return (
    <Stack
      px={4}
      py={2}
      bgcolor="background.paper"
      borderTop="1px solid"
      borderColor="border.main"
      height="100%"
    >
      <Stack direction="row" gap={2} alignItems="center">
        <Search handleSearchChange={handleSearchChange} sx={{ minWidth: 200, width: 270, flexShrink: 0 }} />
        {filters}
        {showAddButton && (
          <Box ml="auto" flexShrink={0}>
            <Add refetch={refetch} companyID={companyID} user={user} />
          </Box>
        )}
      </Stack>

      {isFetching ? (
        <Loader />
      ) : (
        <>
          {!jobAds || jobAds.length === 0 ? (
            <NotFound
              wrapperSx={{ mt: 19 }}
              title="No Job Advertisements found"
              caption={caption}
            />
          ) : (
            <Stack
              flex={1}
              mt={2}
              py={2}
              bgcolor="background.paper"
              borderTop="1px solid"
              borderColor="border.main"
              gap={1}
            >
              {jobAds.map((item) => (
                <ListItem key={item.ad_id} {...item} status={getStatus(item)} adminView={adminView} />
              ))}
            </Stack>
          )}
          <Stack direction="row" justifyContent="center">
            <Pagination
              page={page}
              handlePageChange={handlePageChange}
              itemCount={total}
              itemsPerPage={pageSize}
              onItemsPerPageChange={setPageSize}
            />
          </Stack>
        </>
      )}
    </Stack>
  );
};